import { Component, OnInit,ViewChild } from '@angular/core';
import { subCategory } from '../models/subCategory';
import { ImageCompressService } from 'ng2-image-compress';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../service/tableUtility.service';

@Component({
  selector: 'app-product-sub-category',
  templateUrl: './product-sub-category.component.html',
  styleUrls: ['./product-sub-category.component.css']
})
export class ProductSubCategoryComponent implements OnInit {


  displayedColumns = ['name','categoryName','logo','adminUserName','status','createdDate','modifiedDate','Action']
  myurl:any
  subCategoryAddObj:subCategory
pic: any;
image = { 'URL': '', 'valid': false };
dataSource:any
country:any
 show:boolean=false
 showFilter:boolean=false
 userSessionData:any
 userDetails:any;
 categoriesList:any
 showCheck:boolean=false

 @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("subCategory") form: any;
  @ViewChild("subCategoryUpdate", { static: true }) formUpdate: any;
  tableData: any;
  constructor(private toastr: ToastrManager,private cs:CucurachaAdminService,private excelService: ExcelService) {
    this.subCategoryAddObj=new subCategory()
    this.myurl = this.cs.endpoint;
   }
   check(){
    if(this.showCheck==false){
      this.showCheck=true

    }
    else{
      this.showCheck=false

    }
  }
  filter(){
    if(this.showFilter==false){
      this.showFilter=true

    }
    else{
      this.showFilter=false

    }
  }
  exportTable() {
    this.tableData = (this.dataSource.filteredData)
    this.excelService.exportAsExcelFile(this.tableData, 'Adminuser');
    this.cs.exportLogAdd(this.userDetails.emailId,'sub category management').subscribe((data) => {
    })
  }
  addProductSubCategory(){
    if(this.show==false){
      this.show=true

    }
    else{
      this.show=false

    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  saveSubCategory(){
    console.log(this.userDetails)
    this.subCategoryAddObj.adminId=this.userDetails._id
    this.subCategoryAddObj.adminUserName=this.userDetails.emailId

    this.cs.saveSubCategory(this.subCategoryAddObj).subscribe((data) => {
      if (data.result) {
        this.getAllSubCategories();
        this.toastr.successToastr(data.message);
        this.form.reset();
        this.pic = ""


      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    });
  }
  getAllCategories(){
    this.cs.getAllCategory().subscribe((data) => {
     this.categoriesList=data

    });
  }
  getAllSubCategories(){
    this.cs.getAllSubCategory().subscribe((data) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator

    });
  }
  onChange(status, id) {
    console.log(status.checked)
    this.cs.getSubCategoryById(id).subscribe((data) => {
      this.subCategoryAddObj._id = data[0]._id;

     // this.subCategoryAddObj.id = data[0].id;
      this.subCategoryAddObj.status = status.checked;

      this.cs.updateSubCategoryStatus(this.subCategoryAddObj).subscribe((data) => {
        if(data.result ){
          this.ngOnInit();
          this.toastr.infoToastr(data.message);
          this.form.reset();
          this.pic=""
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
    
         }
          else{
            this.toastr.errorToastr(data.message);
    
          }
      })
    })
  }
  fileChangeEvent(fileInput: any) {
    ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
      observableImages.subscribe((image) => {
        this.image.URL = image.compressedImage.imageDataUrl;
        this.subCategoryAddObj.logo = image.compressedImage.imageDataUrl;
        this.subCategoryAddObj.logo = this.subCategoryAddObj.logo.replace("data:image/gif;base64,", "");
        this.subCategoryAddObj.logo = this.subCategoryAddObj.logo.replace("data:image/jpeg;base64,", "");
        this.subCategoryAddObj.logo = this.subCategoryAddObj.logo.replace("data:image/jpg;base64,", "");
        this.subCategoryAddObj.logo = this.subCategoryAddObj.logo.replace("data:image/png;base64,", "");
        this.pic = image.compressedImage.imageDataUrl
      }, (error) => {
        this.toastr.errorToastr("Error while converting");
      });
    });
  }
  getSubCategoryById(id: any) {
    this.cs.getSubCategoryById(id).subscribe((data) => {
      this.subCategoryAddObj._id = data[0]._id;

    //  this.subCategoryAddObj.id = data[0].id;
      this.subCategoryAddObj.name = data[0].name
      this.subCategoryAddObj.gender = data[0].gender

      this.subCategoryAddObj.categoryId = data[0].categoryId

  
      this.pic = this.myurl + 'misc/Images/subcategorylogos/' + data[0]._id
    })

  }
  updateSubCategory() {
    this.cs.updateSubCategory(this.subCategoryAddObj).subscribe((data) => {
      if (data.result) {
        this.getAllSubCategories();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();

      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    });

  }
  deleteSubCategory(id: any) {
    this.cs.deleteSubCategory(id).subscribe((data) => {
      this.getAllSubCategories()
      this.toastr.warningToastr("Data  Deleted");


    })

  }
  ngOnInit(): void {
    this.getAllSubCategories()
    this.getAllCategories()

    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
    
    })
  }
}
